import React, { Component } from 'react';
import cx from 'classnames';

import { IconButton, ICON_TYPE } from '../font-icons/IconButton'

import './style.scss';

class Pagination extends Component {

  countOfPages = 0;

  static defaultProps = {
    maxVisible: 5,
  };


  renderPageLink(pageNumber) {
    return (
      <div key={pageNumber} className='control'>
        <div
          className={cx('digit btn', { active: this.props.activePage === pageNumber })}
          onClick={() => this.onChange(pageNumber)}
        >
          {pageNumber}
        </div>
      </div>
    );
  }

  onChange(pageNumber) {
    this.props.onChange(pageNumber);
  }


  render() {
    const {
      activePage,
      itemsCountPerPage,
      totalItemsCount,
    } = this.props;

    this.countOfPages = Math.ceil(totalItemsCount / itemsCountPerPage);


    let max = this.countOfPages;
    let skip = 0;
    let maxVisible = this.countOfPages > this.props.maxVisible ? this.props.maxVisible : this.countOfPages;

    if (activePage > maxVisible - 1 && activePage < max) {
      skip = activePage - maxVisible + 1;
    } else if (activePage === max) {
      skip = activePage - maxVisible;
    }

    const iterator = Array(...Array(maxVisible)).map((v, i) => {
      return skip + i + 1;
    });

    return (
      <div className="pagination-wrapper">
        <div className="pagination controls">
          <div className={`control ${activePage === 1 ? 'disabled' : ''}`}>
            <IconButton
              type={ICON_TYPE.GALLERY_FIRST}
              onClick={() => { if (activePage !== 1) this.onChange(1) }}
              disabled={activePage === 1}
            />
          </div>
          <div className={`control ${activePage === 1 ? 'disabled' : ''}`}>
            <IconButton
              type={ICON_TYPE.VIDEO_PREVIOUS}
              onClick={() => { if (activePage !== 1) this.onChange(activePage - 1) }}
              disabled={activePage === 1}
            />
          </div>

          {iterator.map(item => this.renderPageLink(item))}

          <div className={`control ${activePage === this.countOfPages ? 'disabled' : ''}`}>
            <IconButton
              type={ICON_TYPE.VIDEO_NEXT}
              onClick={() => { if (activePage !== this.countOfPages) this.onChange(activePage + 1) }}
              disabled={activePage === this.countOfPages}
            />
          </div>
          <div className={`control ${activePage === this.countOfPages ? 'disabled' : ''}`}>
            <IconButton
              type={ICON_TYPE.GALLERY_LAST}
              onClick={() => { if (activePage !== this.countOfPages) this.onChange(this.countOfPages) }}
              disabled={activePage === this.countOfPages}
            />
          </div>
        </div>
      </div>
    );
  }
}



export default Pagination


// WEBPACK FOOTER //
// ./src/components/pagination/Pagination.jsx